<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'dashboard/composables/store';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import PageLayout from 'dashboard/components-next/ailab/PageLayout.vue';
import AilabPaywall from 'dashboard/components-next/ailab/pageComponents/Paywall.vue';
import ProductInfoPage from 'dashboard/components-next/ailab/svo/ProductInfoPage.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();
const { t } = useI18n();

const assistantId = computed(() => route.params.assistantId);
const uiFlags = useMapGetter('ailabAssistants/getUIFlags');
const isFetching = computed(() => uiFlags.value.fetchingItem);

const assistant = computed(() =>
  store.getters['ailabAssistants/getRecord'](Number(assistantId.value))
);

const productName = computed(() => {
  return (
    assistant.value?.config?.product_name || assistant.value?.name || 'Product'
  );
});

const handleBack = () => {
  router.push({
    name: 'ailab_assistants_edit',
    params: { assistantId: assistantId.value },
  });
};

onMounted(() => {
  if (!assistant.value?.id) {
    store.dispatch('ailabAssistants/show', assistantId.value);
  }
});
</script>

<template>
  <PageLayout
    :header-title="`${productName} - Product Info`"
    :show-pagination-footer="false"
    :is-fetching="isFetching"
    :show-know-more="false"
    :back-url="{ name: 'ailab_assistants_edit', params: { assistantId } }"
    :feature-flag="FEATURE_FLAGS.CAPTAIN"
  >
    <template #headerIcon>
      <div
        class="w-11 h-11 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center text-slate-900 flex-shrink-0"
      >
        <span class="i-lucide-package-search size-5" />
      </div>
    </template>

    <template #headerSubtitle>
      <div class="text-sm text-slate-600">
        Product catalog and content used by this assistant.
      </div>
    </template>

    <template #paywall>
      <AilabPaywall />
    </template>

    <template #body>
      <ProductInfoPage
        :assistant-id="assistantId"
        :product-name="productName"
      />
    </template>
  </PageLayout>
</template>
